import {urlValidateToken} from "../constants/endpoints";
import axios from "axios";
import {useAppContext} from "../contexts/AppContext";
import {useEffect} from "react";

export function useKeepAlive() {
    const { signOut } = useAppContext();

    useEffect(() => {
        const interval = setInterval(async () => {
            try {
                await axios.get(`${urlValidateToken}?aumentarTempo=1`);
            } catch {
                signOut();
            }
        }, 50 * 60 * 1000);

        return () => clearInterval(interval);
    }, []);
}